<template>
  <b-col cols="12">
    <b-row>
      <b-col cols="12">
        <app-button class="pull-right" button_type="new" :c_permission="C_UPLOAD_DOCUMENTS"
                    :disabled="applicant.status && applicant.status.id === STATUS_COMPLETE" @click="openForm">
          {{$t('ADD_DOCUMENT')}}
        </app-button>
      </b-col>
    </b-row>
    <b-row class="mt-3" v-if="documentList.length">
      <b-col cols="12">
        <div class="position-relative">
          <div class="table-container">
            <b-table class="applicant_table animated fadeIn" :fields="fields" :items="documentList" v-if="show"
                     responsive hover>
              <template v-slot:cell(size)="data">
                  {{bytesToSize(data.item.size)}}
              </template>
              <template v-slot:cell(download)="data">

                <DownloadButton :c_permission="C_DOCUMENT_DOWNLOAD_BUTTON"
                                variant="link"
                                size="sm"
                                @click="download(data.item)">
                </DownloadButton>

              </template>
              <template v-slot:cell(delete)="data">

                <delete-button :c_permission="C_DOCUMENT_DELETE_BUTTON"
                               @click="deleteItem(data.item.object_id,data.item.document_type.id, data.item.id)"
                               :disabled="applicant.status && applicant.status.id === STATUS_COMPLETE"
                               class="pull-right">
                </delete-button>

              </template>
            </b-table>
          </div>
        </div>
      </b-col>

    </b-row>

    <delete-dialog :show="showDeleteDialog"
                   :loading="deleteLoading"
                   @confirm="removeItemFromList"
                   @cancel="showDeleteDialog=false; deleteObject={}">
    </delete-dialog>
    <app-aside :widths="['col-xl-4','col-sm-4', '40%']" :state="openSideBar" v-on:closeAside="openSideBar =false">
      <template v-slot:header_text>
        Upload
      </template>
      <document-upload-form @successUpload="updatelist"></document-upload-form>
    </app-aside>
  </b-col>

</template>

<script>
  import {
    C_UPLOAD_DOCUMENTS,
    C_DOCUMENT_DELETE_BUTTON,
    C_DOCUMENT_DOWNLOAD_BUTTON
  } from "@/shared/component_permission";
  import {STATUS_COMPLETE} from "@/shared/constants";
  import DocumentPreview from '@/components/applicant/document/DocumentsPreview'
  import AppButton from "@/components/app/AppButton";
  import AppAside from "@/components/app/AppAside";
  import {deleteDocument, downloadDocument, getDocumentList} from "@/services/document";
  import DocumentUploadForm from "@/components/applicant/document/DocumentUploadForm";
  import DownloadButton from '@/components/app/AppDownload'
  import DeleteButton from '@/components/app/AppDelete'
  import {toast} from "@/shared/plugins/toastr";
  import DeleteDialog from '@/components/app/form/AppConfirmationDialog'
  import {getErrorMessage} from "@/mixins/error/getErrorMessage";

  export default {
    name: "Index",
    mixins: [getErrorMessage],
    data() {
      return {
        ObjectId: Number(this.$route.params.id),
        C_UPLOAD_DOCUMENTS,
        C_DOCUMENT_DELETE_BUTTON,
        C_DOCUMENT_DOWNLOAD_BUTTON,
        STATUS_COMPLETE,
        openSideBar: false,
        show: true,
        deleteLoading: false,
        fields: [
          {key: 'document_type.name', label: this.$t('DOCUMENT_TYPE')},
          {key: 'document_name', label: this.$t('NAME')},
          {key: 'size', label: this.$t('SIZE')},
          {key: 'extension', label: this.$t('TYPE')},
          {key:'download',label:this.$t('DOWNLOAD'), tdClass: "p-0 options-column", thClass:"text-center"},
          {key:'delete',label:this.$t('DELETE'),tdClass:"p-0 options-column", thClass:"text-center"},
        ],
        showDeleteDialog: false,
        documentList: [],
        deleteObject: {}
      }
    },
    computed: {
      applicant() {
        return this.$store.getters['applicant/getApplicant']
      },
    },
    methods: {
      bytesToSize(bytes) {
        let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
      },
      openForm() {
        this.openSideBar = true
      },
      fetchList(object_id) {
        getDocumentList(object_id, 1).then((response) => {
          this.documentList = response.data
        })
      },
      download(item) {
        const name = this.applicant.first_name + '_' + this.applicant.last_name + '_' + item.document_name
        downloadDocument(item.object_id, item.document_type.id, item.id, name, item.extension).then(() => {

        }, error => {
          toast({
            'title': this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
            'message': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
            'type': 'error',
            'timeout': 6000
          })
        })
      },
      removeItemFromList() {
        this.deleteLoading = true
        deleteDocument(this.deleteObject).then((response) => {
            this.documentList = response.data
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
              'message': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'type': 'success',
              'timeout': 3000
            })
          }, error => {
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              'message': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
          }
        ).finally(() => {
          this.deleteLoading = false
          this.showDeleteDialog = false
        })
      },
      deleteItem(object_id, document_type_id, id) {
        this.deleteObject = {
          object_id: object_id,
          document_type_id: document_type_id,
          id: id
        }
        this.showDeleteDialog = true
      },
      updatelist(data) {
        this.documentList = data
        this.openSideBar = false
      }
    },
    components: {
      DocumentUploadForm,
      AppButton,
      DocumentPreview,
      AppAside,
      DownloadButton,
      DeleteButton,
      DeleteDialog
    },
    watch: {
      '$route.params.id': {
        handler(value) {
          this.fetchList(value)
        }, immediate: true
      }
    }
  }
</script>

<style scoped>

</style>
